import {FilterOptions} from '../interfaces/FilterOptions';
const filterOptions: FilterOptions = {
  brand: {
    label: 'Brand',
    values: {},
  },
  geo: {
    label: 'Geo',
    values: {},
  },
  businessStatus: {
    label: 'Status',
    values: {},
  },
};

export default filterOptions;
